import React, {useCallback, useEffect, useState} from "react";
import useStyles from "./styles";
import StyledTabs from "./components/StyledTabs";
import Heading from "./components/Heading";
import {useDispatch, useSelector} from "react-redux";
import {addAssayToOrderList, getCatalog, removeAssayFromOrderList, setListOfPatients} from "@cabinet-packages/redux";
import OrderDatePunkt from "./components/OrderDatePunkt";
import OrderAssays from "./components/OrderAssays";
import OrderTerms from "./components/OrderTerms";
import OrderSummary from "./components/OrderSummary";
import {AccessKey} from "@cabinet-packages/helpers";
import {getPatients} from "@cabinet-packages/api/api";
import {
    togglePersonalData,
    togglePreparationRules,
    toggleUseAction
} from "@cabinet-packages/redux/actions/actionsCreators";

const PatientTabsVdoma = () => {
    const cl = useStyles();
    const dispatch = useDispatch();
    const [tabIndex, setTabIndex] = useState('0');
    const { listOfPatients } = useSelector(state => state.patients);
    const { preparationRules, personalData, takeInOrder, amountOfItems, orderingList, selectedPunkt, promoCode, useAction, timeLine } = useSelector(state => state.orderAssays);
    const [promoCodeState, setPromoCode] = useState('');
    const [state, setState] = useState({checkedA: preparationRules, checkedB: personalData, checkedC: takeInOrder});
    const {catalog, takeId, actions, complexResearch}  = useSelector(state => state.assaysCatalog);
    const { themeMaterialUI } = useSelector(state => state.theme);


    const handleGetPatients = useCallback(async () => {
        if (!listOfPatients && AccessKey.get()) {
            const newListOfPatients = await getPatients();

            dispatch(setListOfPatients(false, false, newListOfPatients));
        }
    }, [dispatch, listOfPatients]);

    useEffect(() => {
        handleGetPatients();
    }, [handleGetPatients]);

    useEffect(() => {
        if (!catalog && takeId) dispatch(getCatalog());
    }, [catalog, takeId]);

    useEffect(() => {
        if (state.checkedA !== preparationRules) {
            dispatch(togglePreparationRules());
        }
        if (state.checkedB !== personalData) {
            dispatch(togglePersonalData());
        }
    }, [state.checkedA, state.checkedB]);

    useEffect(() => {
        if (amountOfItems && actions && orderingList && catalog && complexResearch) {
            orderingList.forEach(item => {
                const foundedAction = actions.find(action => action.active === 'Y' && action.idGrTest.includes(item.id));
                const fullItem = [...catalog, ...complexResearch].find(assay => +assay.id === +item.id && assay.type === item.type);
                if (foundedAction && foundedAction.idPunkts.includes(selectedPunkt.idPunkt) && fullItem && !useAction) {
                    dispatch(toggleUseAction());
                    //remove item
                    if (!promoCode || (promoCode && promoCode.type === 'none')) {
                        dispatch(removeAssayFromOrderList(
                            fullItem.id,
                            fullItem.discount
                                ? fullItem.price - fullItem.price * fullItem.discount / 100
                                : fullItem.price,
                            () => {},
                            fullItem.type,
                        ));
                    } else if (promoCode && promoCode.type === 'specified') {
                        const foundDiscount = promoCode.grtests.find(item => +item[0] === +fullItem.id);

                        if (foundDiscount) {
                            dispatch(removeAssayFromOrderList(
                                fullItem.id,
                                +foundDiscount[1] === 0 ? +fullItem.price - (+fullItem.price * (+foundDiscount[2]/100)) : +foundDiscount[1],
                                () => {},
                                fullItem.type));
                        } else {
                            dispatch(removeAssayFromOrderList(
                                fullItem.id,
                                +fullItem.price - (+fullItem.price * (+fullItem.discount/100)),
                                () => {},
                                fullItem.type));
                        }
                    } else if (promoCode && promoCode.type === 'notdisc') {
                        const discount = fullItem.opt && fullItem.opt.includes(promoCode.type) ? fullItem.discount : promoCode.discount;
                        if (fullItem.idParent !== takeId) {
                            dispatch(removeAssayFromOrderList(fullItem.id, +fullItem.price - (+fullItem.price * (+discount/100)),
                                () => {}, fullItem.type))
                        }
                    } else if (promoCode && promoCode.type === 'all') {
                        if (fullItem.idParent !== takeId) {
                            dispatch(removeAssayFromOrderList(fullItem.id, +fullItem.price - (+fullItem.price * (+promoCode.discount/100)),
                                () => {}, fullItem.type))
                        }
                    }

                    //add same item
                    if (!promoCode || (promoCode && promoCode.type === 'none')) {
                        dispatch(addAssayToOrderList(
                            fullItem.id,
                            foundedAction.price,
                            () => {},
                            fullItem.type,
                        ));
                    } else if (promoCode && promoCode.type === 'specified') {
                        const foundDiscount = promoCode.grtests.find(item => +item[0] === +fullItem.id);

                        if (foundDiscount) {
                            dispatch(addAssayToOrderList(
                                fullItem.id,
                                +foundDiscount[1] === 0 ? +foundedAction.price - (+foundedAction.price * (+foundDiscount[2]/100)) : +foundDiscount[1],
                                () => {},
                                fullItem.type));
                        } else {
                            dispatch(addAssayToOrderList(
                                fullItem.id,
                                +foundedAction.price,
                                () => {},
                                fullItem.type));
                        }
                    } else if (promoCode && promoCode.type === 'notdisc') {
                        const discount = fullItem.opt && fullItem.opt.includes(promoCode.type) ? 0 : promoCode.discount;
                        if (fullItem.idParent !== takeId) {
                            dispatch(addAssayToOrderList(fullItem.id, +foundedAction.price - (+foundedAction.price * (+discount/100)),
                                () => {}, fullItem.type))
                        }
                    } else if (promoCode && promoCode.type === 'all') {
                        if (fullItem.idParent !== takeId) {
                            dispatch(addAssayToOrderList(fullItem.id, +foundedAction.price - (+foundedAction.price * (+promoCode.discount/100)),
                                () => {}, fullItem.type))
                        }
                    }
                } else if (foundedAction && !foundedAction.idPunkts.includes(selectedPunkt.idPunkt) && fullItem && useAction) {//if punkt not in action
                    dispatch(toggleUseAction());
                    //remove item
                    if (!promoCode || (promoCode && promoCode.type === 'none')) {
                        dispatch(removeAssayFromOrderList(
                            fullItem.id,
                            fullItem.discount
                                ? fullItem.price - fullItem.price * fullItem.discount / 100
                                : fullItem.price,
                            () => {},
                            fullItem.type,
                        ));
                    } else if (promoCode && promoCode.type === 'specified') {
                        const foundDiscount = promoCode.grtests.find(item => +item[0] === +fullItem.id);

                        if (foundDiscount) {
                            dispatch(removeAssayFromOrderList(
                                fullItem.id,
                                +foundDiscount[1] === 0 ? +fullItem.price - (+fullItem.price * (+foundDiscount[2]/100)) : +foundDiscount[1],
                                () => {},
                                fullItem.type));
                        } else {
                            dispatch(removeAssayFromOrderList(
                                fullItem.id,
                                +fullItem.price - (+fullItem.price * (+fullItem.discount/100)),
                                () => {},
                                fullItem.type));
                        }
                    } else if (promoCode && promoCode.type === 'notdisc') {
                        const discount = fullItem.opt && fullItem.opt.includes(promoCode.type) ? fullItem.discount : promoCode.discount;
                        if (fullItem.idParent !== takeId) {
                            dispatch(removeAssayFromOrderList(fullItem.id, +fullItem.price - (+fullItem.price * (+discount/100)),
                                () => {}, fullItem.type))
                        }
                    } else if (promoCode && promoCode.type === 'all') {
                        if (fullItem.idParent !== takeId) {
                            dispatch(removeAssayFromOrderList(fullItem.id, +fullItem.price - (+fullItem.price * (+promoCode.discount/100)),
                                () => {}, fullItem.type))
                        }
                    }

                    //add item
                    if (!promoCode || (promoCode && promoCode.type === 'none')) {
                        dispatch(addAssayToOrderList(
                            fullItem.id,
                            fullItem.discount
                                ? fullItem.price - fullItem.price * fullItem.discount / 100
                                : fullItem.price,
                            () => {},
                            fullItem.type,
                        ));
                    } else if (promoCode && promoCode.type === 'specified') {
                        const foundDiscount = promoCode.grtests.find(item => +item[0] === +fullItem.id);

                        if (foundDiscount) {
                            dispatch(addAssayToOrderList(
                                fullItem.id,
                                +foundDiscount[1] === 0 ? +fullItem.price - (+fullItem.price * (+foundDiscount[2]/100)) : +foundDiscount[1],
                                () => {},
                                fullItem.type));
                        } else {
                            dispatch(addAssayToOrderList(
                                fullItem.id,
                                +fullItem.price - (+fullItem.price * (+fullItem.discount/100)),
                                () => {},
                                fullItem.type));
                        }
                    } else if (promoCode && promoCode.type === 'notdisc') {
                        const discount = fullItem.opt && fullItem.opt.includes(promoCode.type) ? fullItem.discount : promoCode.discount;
                        if (fullItem.idParent !== takeId) {
                            dispatch(addAssayToOrderList(fullItem.id, +fullItem.price - (+fullItem.price * (+discount/100)),
                                () => {}, fullItem.type))
                        }
                    } else if (promoCode && promoCode.type === 'all') {
                        if (fullItem.idParent !== takeId) {
                            dispatch(addAssayToOrderList(fullItem.id, +fullItem.price - (+fullItem.price * (+promoCode.discount/100)),
                                () => {}, fullItem.type))
                        }
                    }
                }
            });
        }
    }, [actions, catalog, complexResearch]);

    // useEffect(() => {
    //     CustomDialog(TextAlertDialogMedis, {text: (<span style={{color: 'black', textAlign: 'center'}}>У святковий період перевіряйте актуальний графік роботи відділень на <a href="https://www.medis.com.ua/" target="_blank" style={{textDecoration: 'none', color: '#0E4E4E'}}>сайті</a> або у Google</span>)}, false, themeMaterialUI)
    // }, []);

    return (<div className={cl.rootWrapper}>
        <div className={cl.root}>
            <Heading/>
            <StyledTabs selectedTab={[tabIndex, setTabIndex]}/>
            {listOfPatients && <OrderDatePunkt selectedPatient={listOfPatients[tabIndex]}/>}
            <OrderAssays/>
            <OrderTerms checkboxes={[state, setState]} promo={[promoCodeState, setPromoCode]}/>
            <OrderSummary/>
        </div>
    </div>);
};

export default PatientTabsVdoma;
